import React from 'react';

const BrandInformation = () => {
    return (
        <div className="brand-information-wrapper xpt-5 xpt-lg-20">
            <div className="container">
                <div className="brand-description">
                    <p className="text">
                        برند بیسوس یا همان باسئوس (Baseus) با پایدار ماندن به شعار تجاری خود یعنی ‌Base on user به شهرت
                        جهانی رسیده است. با وجود گستردگی بازار لوازم جانبی، برند بیسوس اسم و رسمی برای خود بهم زده و
                        نیاز به
                        معرفی کمی دارد. اما اگر قصد خرید محصولات بیسوس را داشته باشید، خوب است بیشتر با تاریخچه برند
                        بیسوس،
                        قیمت محصولات بیسوس و ایده‌های پشت شهرت این برند آشنا شوید.
                    </p>
                    <p className="established-year persian-number">سال تاسیس: 2011
                    </p>
                    <p className="text">
                        اگر به نام انگلیسی بیسوس یعنی Baseus دقت کنید، متوجه می‌شوید که از خلاصه کردن شعار آن‌ها یعنی
                        «برپایه کاربر» گرفته شده است. این نام و شعار تأکید بر فلسفه برند باسئوس، فکر کردن از دید کاربر و
                        طراحی کالا با در نظر گرفتن او دارد که باسئوس با آن معرفی می‌شود. فلسفه‌ای که با پایبند بودن به
                        آن در
                        طی تنها یک دهه، موفقیت بسیار ی در بازار چین به ارمغان آورده است.
                    </p>
                </div>
                <div className="drop-down-text-brand">
                    <div className="accordion-item xmt-4">
                        <div className="accordion-header accordion-button collapsed" id="brand-description-drop-one"
                             data-bs-toggle="collapse"
                             data-bs-target="#panels-stay-open-collapse-one" aria-expanded="false"
                             aria-controls="panels-stay-open-collapse-one">
                            <span className="title-toggle">
                                محصولات بیسوس (‌Baseus) : از کابل شارژ تا  پاوربانک
                            </span>
                        </div>
                        <div id="panels-stay-open-collapse-one" className="accordion-collapse collapse"
                             aria-labelledby="brand-description-drop-one">
                            <div className="accordion-body">
                                <p className="text">این برند چینی از زمان ورود به ایران با استقبال و بازخورد مثبت
                                    کاربران ایرانی مواجه شده‌ است. در حال حاضر انواع شارژر و پاوربانک، کابل و پایه‌های
                                    نگهدارنده این شرکت در ایران به فروش می‌رسد. </p>
                            </div>
                        </div>
                    </div>
                    <div className="accordion-item xmt-4">
                        <div className="accordion-header accordion-button collapsed" id="brand-description-drop-two"
                             data-bs-toggle="collapse"
                             data-bs-target="#panels-stay-open-collapse-two" aria-expanded="false"
                             aria-controls="panels-stay-open-collapse-two">
                            <span className="title-toggle">
                            علت موفقیت برند باسئوس چیست؟
                            </span>
                        </div>
                        <div id="panels-stay-open-collapse-two" className="accordion-collapse collapse"
                             aria-labelledby="brand-description-drop-two">
                            <div className="accordion-body">
                                <p className="text">این برند چینی از زمان ورود به ایران با استقبال و بازخورد مثبت
                                    کاربران ایرانی مواجه شده‌ است. در حال حاضر انواع شارژر و پاوربانک، کابل و پایه‌های
                                    نگهدارنده این شرکت در ایران به فروش می‌رسد. </p>
                            </div>
                        </div>
                    </div>
                    <div className="accordion-item xmt-4">
                        <div className="accordion-header accordion-button collapsed" id="brand-description-drop-three"
                             data-bs-toggle="collapse"
                             data-bs-target="#panels-stay-open-collapse-three" aria-expanded="false"
                             aria-controls="panels-stay-open-collapse-three">
                            <span className="title-toggle">
          محصولات باسئوس در ایران
                            </span>
                        </div>
                        <div id="panels-stay-open-collapse-three" className="accordion-collapse collapse"
                             aria-labelledby="brand-description-drop-three">
                            <div className="accordion-body">
                                <p className="text">این برند چینی از زمان ورود به ایران با استقبال و بازخورد مثبت
                                    کاربران ایرانی مواجه شده‌ است. در حال حاضر انواع شارژر و پاوربانک، کابل و پایه‌های
                                    نگهدارنده این شرکت در ایران به فروش می‌رسد. </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BrandInformation;
